(() => {
  if (window.__qrFeatureScrollInit) return;
  window.__qrFeatureScrollInit = true;

  const initFeatureScroll = (root) => {
    const scope = root || document;
    scope.querySelectorAll('.feature-scroll:not([data-feature-ready])').forEach((section) => {
      section.dataset.featureReady = 'true';

      const triggers = Array.from(section.querySelectorAll('[data-feature-trigger]'));
      const subtexts = Array.from(section.querySelectorAll('[data-feature-subtext]'));
      const media = Array.from(section.querySelectorAll('[data-feature-media]'));
      const progressBars = Array.from(section.querySelectorAll('[data-feature-progress]'));
      const count = triggers.length;
      if (!count) return;

      const intervalMs = parseInt(section.dataset.featureInterval, 10) || 6000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let activeIndex = 0;
      let timer = null;
      let inView = false;

      const restartTimer = () => {
        window.clearTimeout(timer);
        if (reduceMotion || !inView) return;
        timer = window.setTimeout(() => setActive(activeIndex + 1), intervalMs);
      };

      function setActive(index) {
        activeIndex = ((index % count) + count) % count;

        triggers.forEach((btn, i) => {
          const isActive = i === activeIndex;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', String(isActive));
        });
        subtexts.forEach((el, i) => el.classList.toggle('is-active', i === activeIndex));
        media.forEach((el, i) => el.classList.toggle('is-active', i === activeIndex));

        if (!reduceMotion) {
          progressBars.forEach((bar, i) => {
            bar.classList.remove('is-running');
            if (i === activeIndex) {
              // Force a reflow so the fill animation restarts from zero.
              void bar.offsetWidth;
              bar.style.setProperty('--feature-duration', intervalMs + 'ms');
              bar.classList.add('is-running');
            }
          });
        }

        restartTimer();
      }

      triggers.forEach((btn, i) => {
        btn.addEventListener('click', () => setActive(i));
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            inView = entry.isIntersecting;
            if (inView) {
              restartTimer();
            } else {
              window.clearTimeout(timer);
              progressBars.forEach((bar) => bar.classList.remove('is-running'));
            }
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(section);

      // Set the initial active state without starting the timer yet;
      // the IntersectionObserver kicks the timer off once it's in view.
      triggers.forEach((btn, i) => {
        const isActive = i === 0;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      });
      subtexts.forEach((el, i) => el.classList.toggle('is-active', i === 0));
      media.forEach((el, i) => el.classList.toggle('is-active', i === 0));
    });
  };

  document.addEventListener('DOMContentLoaded', () => initFeatureScroll());
  document.addEventListener('shopify:section:load', (event) => initFeatureScroll(event.target));

  if (document.readyState !== 'loading') {
    initFeatureScroll();
  }
})();
